import { render } from "./DynamicFormModal.vue?vue&type=template&id=2aab6111&ts=true"
import script from "./DynamicFormModal.vue?vue&type=script&lang=ts"
export * from "./DynamicFormModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__